import { colors } from '@creditornot/cb-ingredients';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ImageCoverageRecord } from 'apis/merchant-gateway/insights/image-coverage/types';
import { HorizontalBarChart, LegendChartType } from 'modules/experience-core';

export type ImageCoverageChartProps = {
  imageCoverageRecords: ImageCoverageRecord[];
};

export const ImageCoverageChart = ({ imageCoverageRecords }: ImageCoverageChartProps) => {
  const { formatMessage } = useIntl();

  const chartData = useMemo(
    () =>
      imageCoverageRecords.map(item => {
        return {
          name: item.secondaryLabel,
          summaryValue: Math.floor(item.coverage * 100),
          imageCoverage: item.coverage,
        };
      }),
    [imageCoverageRecords],
  );

  return (
    <HorizontalBarChart
      legends={{
        imageCoverage: {
          value: formatMessage({ id: 'insights.menu.image-coverage.section.title' }),
          color: colors.wolt72,
          type: LegendChartType.BAR,
        },
      }}
      customTickFormatter={(value: number) => `${value * 100}%`}
      isStacked={false}
      isLegendUiVisible={false}
      barSize={20}
      data={chartData}
      summaryKey="insights.menu.image-coverage.section.title"
    />
  );
};
